import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Grid,
  List,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import Header from "../components/header";
import componentStyles from "../assets/styles/containers/issues";
import CustomBox from "../components/templates/customBox";
import { useTasks } from "../hooks/useTasks";
import { useIssueStatuses } from "../hooks/useIssueStatuses";
import TaskListItem from "../components/task_list_item";
import CreateIssueForm from "../components/organisms/create_issue_form";
import AppContext from "../contexts/AppContext";

const useStyles = makeStyles(componentStyles);
const Tasks = () => {
  const { state } = useContext(AppContext);
  const [open, setOpen] = useState(false);
  const [taskListStatus, setTaskListStatus] = useState({});
  const classes = useStyles();
  const project_id = undefined;
  const allStatus = "*";
  const [requestStatusId, setRequestStatusId] = useState(allStatus);
  const { t } = useTranslation();
  const { loading, setLoading, readTasks, updateTask, tasks, errors, init } =
    useTasks();
  const { getIssueStatuses, issueStatuses } = useIssueStatuses();

  const handleClickFilter = (requestValue) => {
    setLoading(true);
    setRequestStatusId(requestValue);
    readTasks(1, project_id, requestValue);
  };

  const handleClickCreateTaskOpen = () => setOpen(true);

  const defaultTaskListStatus = () => {
    let defaultStatus = {};
    issueStatuses.forEach((status) => {
      if (!status.is_closed && !defaultStatus.progress) {
        defaultStatus["progress"] = {
          id: status.id.toString(),
          name: status.name,
        };
      } else if (status.is_closed && !defaultStatus.closed) {
        defaultStatus["closed"] = {
          id: status.id.toString(),
          name: status.name,
        };
      }
    });
    return defaultStatus;
  };

  useEffect(() => {
    setLoading(true);
    if (init) readTasks(1, project_id, requestStatusId);
  }, [init]);

  useEffect(() => {
    state.siteConfigs?.forEach((config) => {
      if (config.id === state.current.id) {
        getIssueStatuses({
          redmineurl: config.redmineurl,
          apikey: config.apikey,
        });
      }
    });
  }, [state.current, state.siteConfigs]);

  useEffect(() => {
    state.siteConfigs?.forEach((config) => {
      if (config.id === state.current.id) {
        setTaskListStatus(config.taskListStatus || defaultTaskListStatus());
      }
    });
  }, [issueStatuses]);

  return (
    <>
      <Header />

      <Container
        maxWidth={false}
        component={Box}
        marginTop="-6rem"
        classes={{ root: classes.containerRoot }}
      >
        <Card classes={{ root: classes.cardRoot }}>
          <CardHeader
            className={classes.cardHeader}
            subheader={
              <Grid
                container
                component={Box}
                alignItems="center"
                justifyContent="space-between"
                spacing={1}
              >
                <Grid item xs="auto">
                  <Box
                    component={Typography}
                    variant="h3"
                    marginBottom="0!important"
                  >
                    {t("label_tasks")}
                  </Box>
                </Grid>
                <Grid container>
                  <Grid>
                    <Button onClick={() => handleClickFilter(allStatus)}>
                      {t("task_status.all")}
                    </Button>
                  </Grid>
                  <Grid>
                    <Button
                      onClick={() =>
                        handleClickFilter(taskListStatus.progress?.id)
                      }
                    >
                      {t("task_status.in_progress")}
                    </Button>
                  </Grid>
                  <Grid>
                    <Button
                      onClick={() =>
                        handleClickFilter(taskListStatus.closed?.id)
                      }
                    >
                      {t("task_status.closed")}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            }
          ></CardHeader>
          <CardContent>
            <CustomBox loading={loading} errors={errors}>
              <List>
                {tasks.issues
                  ? tasks.issues.map((issue, index) => {
                      return (
                        <TaskListItem
                          key={index}
                          issue={issue}
                          updateTask={updateTask}
                          taskListStatus={taskListStatus}
                        />
                      );
                    })
                  : null}
              </List>
            </CustomBox>
            <Button onClick={handleClickCreateTaskOpen}>
              {t("tasks.create")}
            </Button>
            <CreateIssueForm project_id={1} open={open} setOpen={setOpen} />
          </CardContent>
        </Card>
      </Container>
    </>
  );
};

export default Tasks;
